/**
 * Price-impact severity for aggregator quotes.
 *
 * The existing `warningSeverity` works on the SDK's `Percent` type derived from a
 * Trade, which an aggregator quote is not - it reports impact in basis points. Same
 * thresholds, same severity scale, so both paths warn at identical points and the UI
 * can treat the two interchangeably.
 *
 * 0 = negligible · 1 = low (>1%) · 2 = medium (>3%) · 3 = high (>5%) · 4 = severe (>15%)
 */

export const IMPACT_TIER_BPS = {
  LOW: 100,
  MEDIUM: 300,
  HIGH: 500,
  SEVERE: 1500,
}

export function severityFromBps(priceImpactBps: number | undefined): number {
  if (priceImpactBps === undefined) return 0

  // Sources disagree on sign: some report impact as negative, some positive.
  const impact = Math.abs(priceImpactBps)

  if (impact > IMPACT_TIER_BPS.SEVERE) return 4
  if (impact > IMPACT_TIER_BPS.HIGH) return 3
  if (impact > IMPACT_TIER_BPS.MEDIUM) return 2
  if (impact > IMPACT_TIER_BPS.LOW) return 1
  return 0
}

/**
 * Whether a trade needs an explicit acknowledgement before it can be signed.
 * Mirrors the router path's behaviour, where expert mode opts out of the extra gate.
 */
export function requiresImpactConfirmation(priceImpactBps: number | undefined, isExpertMode: boolean): boolean {
  return !isExpertMode && severityFromBps(priceImpactBps) > 3
}
